import { __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack } from '../../Stack/Stack.js';
import { Text } from '../../Text/Text.js';
import { Box } from '../../Box/index.js';

var FieldFooter = function (_a) {
    var error = _a.error, hint = _a.hint, fieldId = _a.fieldId;
    return (jsxs(Stack, __assign({ gap: "3" }, { children: [Boolean(hint) && (jsx(Text, __assign({ id: "".concat(fieldId, "-hint"), size: "sm", tone: "subtle", crop: true }, { children: hint }))), Boolean(error) && (jsx(Box, __assign({ role: "alert" }, { children: jsx(Text, __assign({ size: "sm", tone: "critical", id: "".concat(fieldId, "-error"), crop: true }, { children: error })) })))] })));
};

export { FieldFooter };
//# sourceMappingURL=index.js.map
